import { css, styled } from 'styled-components';

export const StyledFormFieldError = styled.div`
  ${({ theme }) => css`
    margin-top: 8px;
    padding-right: 16px;

    color: ${theme.colorsV2.red50};
    font-size: 12px;
  `}
`;
